import type React from "react";

export function ClockIcon(): React.ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.444"
      height="23.444"
      viewBox="0 0 23.444 23.444"
      display="block"
      fill="currentColor"
    >
      <title>Clock</title>
      <g id="noun_clock_3465470" transform="translate(-19 -19)">
        <g id="Group_2641" data-name="Group 2641" transform="translate(19 19)">
          <path
            id="Path_2383"
            data-name="Path 2383"
            d="M48.258,41.177l4.111,4.369a.756.756,0,0,0,1.1-1.037L49.36,40.141a.973.973,0,0,0-.221-.557V35.006a.756.756,0,1,0-1.513,0v4.577a.974.974,0,0,0,.632,1.593Z"
            transform="translate(-36.66 -28.483)"
          />
          <path
            id="Path_2384"
            data-name="Path 2384"
            d="M19,37.871c0,3.077,1.5,4.573,4.573,4.573h14.3c3.077,0,4.573-1.5,4.573-4.573v-14.3c0-3.077-1.5-4.573-4.573-4.573h-14.3C20.5,19,19,20.5,19,23.573ZM30.722,20.891a9.832,9.832,0,1,1-9.832,9.832A9.843,9.843,0,0,1,30.722,20.891Z"
            transform="translate(-19 -19)"
          />
        </g>
      </g>
    </svg>
  );
}
